import React from 'react';
import { Link } from 'react-router-dom';
function PortalAside() {
    const aside = [
        {
            s_id:1,
            s_name : "API",
            s_path : "/example/api"
        },
        {
            s_id:2,
            s_name : "IBSheet",
            s_path : "/example/ibsheet"
        },
        {
            s_id:3,
            s_name : "KUpload",
            s_path : "/example/kupload"
        },
        {
            s_id:4,
            s_name : "Report",
            s_path : "/example/report"
        },
        {
            s_id:5,
            s_name : "UI",
            s_path : "/example/ui"
        },
        {
            s_id:6,
            s_name : "File",
            s_path : "/example/file"
        },
        {
            s_id:7,
            s_name : "전자서명",
            s_path : "/example/esign"
        },
        {
            s_id:8,
            s_name : "휴대폰본인인증",
            s_path : "/example/pass"
        },
        {
            s_id:9,
            s_name : "SMS 발송",
            s_path : "/example/sms"
        }
    ];
    return (
        <aside className='fww-aside'>
            <p className="tit-d1">샘플예제</p>
            <ul className='d1'>
                {aside.map((aside) => (
                    <li key={aside.s_id}>
                        <Link to={aside.s_path} className='no-sub'>{aside.s_name}</Link>
                    </li>
                ))}
            </ul>
        </aside>
    );
}
export default PortalAside;